/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  SettingsBillingProtocolsAddPaymentMethodResponse,
  SettingsBillingProtocolsDeletePaymentMethodRequest,
  SettingsBillingProtocolsGetBillingHistoryResponse,
  SettingsBillingProtocolsGetCustomerInfoResponse,
  SettingsBillingProtocolsGetPaymentMethodResponse,
  SettingsBillingProtocolsGetSetupIntentResponse,
  SettingsBillingProtocolsGetSubscriptionPlansResponse,
  SettingsBillingProtocolsSetDefaultPaymentMethodRequest,
  SettingsBillingProtocolsUpdateCustomerInfoRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Billing<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Billing
   * @name BillingSubscriptionPlansList
   * @request GET:/settings/billing/subscription/plans
   */
  billingSubscriptionPlansList = (params: RequestParams = {}) =>
    this.http.request<SettingsBillingProtocolsGetSubscriptionPlansResponse, any>({
      path: `/settings/billing/subscription/plans`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Billing
   * @name BillingCustomerInfoList
   * @request GET:/settings/billing/customer-info
   */
  billingCustomerInfoList = (params: RequestParams = {}) =>
    this.http.request<SettingsBillingProtocolsGetCustomerInfoResponse, any>({
      path: `/settings/billing/customer-info`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Billing
   * @name BillingCustomerInfoUpdateCreate
   * @request POST:/settings/billing/customer-info/update
   */
  billingCustomerInfoUpdateCreate = (
    data: SettingsBillingProtocolsUpdateCustomerInfoRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/settings/billing/customer-info/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Billing
   * @name BillingPaymentMethodList
   * @request GET:/settings/billing/payment-method
   */
  billingPaymentMethodList = (params: RequestParams = {}) =>
    this.http.request<SettingsBillingProtocolsGetPaymentMethodResponse, any>({
      path: `/settings/billing/payment-method`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Billing
   * @name BillingPaymentMethodSetupIntentList
   * @request GET:/settings/billing/payment-method/setup-intent
   */
  billingPaymentMethodSetupIntentList = (params: RequestParams = {}) =>
    this.http.request<SettingsBillingProtocolsGetSetupIntentResponse, any>({
      path: `/settings/billing/payment-method/setup-intent`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Billing
   * @name BillingPaymentMethodAddList
   * @request GET:/settings/billing/payment-method/add
   */
  billingPaymentMethodAddList = (params: RequestParams = {}) =>
    this.http.request<SettingsBillingProtocolsAddPaymentMethodResponse, any>({
      path: `/settings/billing/payment-method/add`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Billing
   * @name BillingPaymentMethodDeleteCreate
   * @request POST:/settings/billing/payment-method/delete
   */
  billingPaymentMethodDeleteCreate = (
    data: SettingsBillingProtocolsDeletePaymentMethodRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/settings/billing/payment-method/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Billing
   * @name BillingPaymentMethodSetDefaultCreate
   * @request POST:/settings/billing/payment-method/set-default
   */
  billingPaymentMethodSetDefaultCreate = (
    data: SettingsBillingProtocolsSetDefaultPaymentMethodRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/settings/billing/payment-method/set-default`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Billing
   * @name BillingBillingHistoryList
   * @request GET:/settings/billing/billing-history
   */
  billingBillingHistoryList = (params: RequestParams = {}) =>
    this.http.request<SettingsBillingProtocolsGetBillingHistoryResponse, any>({
      path: `/settings/billing/billing-history`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
